import React, { Component, PropTypes } from 'react'
import withCdnUrl from './withCdnUrl'

export class Investors extends Component {
  render() {
    return (
      <section className="investors">
        <div className="container">
          <div className="section__head">
            <h2>Proudly backed by these investors</h2>
            <p>
              We've raised $46,000,000 from top VCs like NEA, Science Inc, and Crosscut Ventures. In other
              words, we’re here to stay.
            </p>
          </div>
          <div className="section__body">
            <div className="row">
              <div className="column--fifth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/NEA.svg`} />
                </div>
              </div>
              <div className="column--fifth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/science.svg`} />
                </div>
              </div>
              <div className="column--fifth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/ElysianPark-logo.svg`} />
                </div>
              </div>
              <div className="column--fifth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/coatue.png`} />
                </div>
              </div>
              <div className="column--fifth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/Crosscut.svg`} />
                </div>
              </div>
            </div>
            <div className="row--divider">
              <p>And independent investors including:</p>
            </div>
            <div className="row--thinner">
              <div className="column--third">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/David-Drummond.png`} />
                  <div className="meta">
                    <h6>
                      David Drummond
                      <small>SVP, Alphabet</small>
                    </h6>
                  </div>
                </div>
              </div>

              <div className="column--third">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/Sean-Combs.png`} />
                  <div className="meta">
                    <h6>
                      Sean “Diddy” Combs
                      <small>Mogul</small>
                    </h6>
                  </div>
                </div>
              </div>

              <div className="column--third">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/Kevin-Lin.png`} />
                  <div className="meta">
                    <h6>
                      Kevin Lin
                      <small>Cofounder, Twitch</small>
                    </h6>
                  </div>
                </div>
              </div>

              <div className="column--third">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/Rahul-Mehta.png`} />
                  <div className="meta">
                    <h6>
                      Rahul Mehta
                      <small>Partner, DST Global</small>
                    </h6>
                  </div>
                </div>
              </div>

              <div className="column--third">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/Michael-Dubin.png`} />
                  <div className="meta">
                    <h6>
                      Michael Dubin
                      <small>CEO, Dollar Shave Club</small>
                    </h6>
                  </div>
                </div>
              </div>

              <div className="column--third">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/investors/Rich-Dennis.png`} />
                  <div className="meta">
                    <h6>
                      Rich Dennis
                      <small>Founder, Shea Moisture</small>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withCdnUrl(Investors)



// WEBPACK FOOTER //
// ./src/common/ui/components/investors.js